var _path, _g, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3018_605",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V45H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3018_605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.10938 12.8379V7.88982C3.10938 5.25012 5.24942 3.11007 7.88913 3.11007H12.7213",
    fill: "#EBF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10938 12.8379V7.88982C3.10938 5.25012 5.24942 3.11007 7.88913 3.11007H12.7213",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.826 41.8906H7.88913C5.24942 41.8906 3.10938 39.7506 3.10938 37.1109V32.1428",
    fill: "#EBF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.826 41.8906H7.88913C5.24942 41.8906 3.10938 39.7506 3.10938 37.1109V32.1428",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8917 32.2414V37.1109C41.8917 39.7506 39.7516 41.8906 37.1119 41.8906H32.2461",
    fill: "#EBF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8916 32.2414V37.1109C41.8916 39.7506 39.7516 41.8906 37.1119 41.8906H32.2461",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3359 3.11064H37.112C39.7517 3.11064 41.8918 5.25069 41.8918 7.8904V12.7637",
    fill: "#EBF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3359 3.11064H37.112C39.7517 3.11064 41.8918 5.25069 41.8918 7.8904V12.7637",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3274 35.1534C25.1523 35.5006 23.9087 35.6869 22.6211 35.6869C21.3335 35.6869 20.0898 35.5006 18.9147 35.1534C14.6793 33.9027 11.3395 30.5629 10.0888 26.3274C9.7416 25.1523 9.55527 23.9088 9.55527 22.6211C9.55527 21.3335 9.7416 20.0898 10.0888 18.9147C11.3395 14.6794 14.6793 11.3395 18.9147 10.0888C20.0898 9.7416 21.3335 9.55527 22.6211 9.55527C23.9087 9.55527 25.1523 9.7416 26.3274 10.0888C30.5629 11.3395 33.9027 14.6794 35.1534 18.9147C35.5006 20.0898 35.6869 21.3335 35.6869 22.6211C35.6869 23.9088 35.5006 25.1523 35.1534 26.3274C33.9027 30.5629 30.5629 33.9027 26.3274 35.1534ZM43.7368 17.9533C41.9334 9.75918 35.483 3.30888 27.289 1.50537C25.786 1.17411 24.2242 0.999996 22.6211 0.999996C21.018 0.999996 19.4562 1.17411 17.9532 1.50537C9.75918 3.30888 3.30889 9.75918 1.50537 17.9533C1.17411 19.4562 1 21.018 1 22.6211C1 24.2242 1.17411 25.786 1.50537 27.289C3.30889 35.483 9.75918 41.9334 17.9532 43.7368C19.4562 44.0682 21.018 44.2422 22.6211 44.2422C24.2242 44.2422 25.786 44.0682 27.289 43.7368C35.483 41.9334 41.9334 35.483 43.7368 27.289C44.0682 25.786 44.2422 24.2242 44.2422 22.6211C44.2422 21.018 44.0682 19.4562 43.7368 17.9533Z",
    fill: "url(#paint0_linear_3018_605)",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0637 9.88672L18.1406 1.64636",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1027 1.64636L26.1797 9.88672",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1406 43.5957L19.0637 35.3553",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1797 35.3553L27.1027 43.5957",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5958 27.1016L35.3555 26.1784",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3555 19.0625L43.5958 18.1394",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64453 18.1394L9.88489 19.0625",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88489 26.1784L1.64453 27.1016",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 9.5C25.8333 7.33344 26.5 2.80032 26.5 2.00032C26.5 1.20032 21.5 1.66698 19 2.00032L19.5 9.5H25.5Z",
    fill: "#EBF5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25.5C38.1666 25.8333 42.6997 26.5 43.4997 26.5C44.2997 26.5 43.833 21.5 43.4997 19L36 19.5L36 25.5Z",
    fill: "#EBF5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5C7.33344 19.1667 2.24172 19 1.44172 19C0.641724 19 1.10839 24 1.44172 26.5L9 26L9.5 19.5Z",
    fill: "#EBF5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 36C19.1667 38.1666 19 42.6997 19 43.4997C19 44.2997 24 43.833 26.5 43.4997L26 36L19.5 36Z",
    fill: "#EBF5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3274 35.1534C25.1523 35.5006 23.9087 35.6869 22.6211 35.6869C21.3335 35.6869 20.0898 35.5006 18.9147 35.1534C14.6793 33.9027 11.3395 30.5629 10.0888 26.3274C9.7416 25.1523 9.55527 23.9088 9.55527 22.6211C9.55527 21.3335 9.7416 20.0898 10.0888 18.9147C11.3395 14.6794 14.6793 11.3395 18.9147 10.0888C20.0898 9.7416 21.3335 9.55527 22.6211 9.55527C23.9087 9.55527 25.1523 9.7416 26.3274 10.0888C30.5629 11.3395 33.9027 14.6794 35.1534 18.9147C35.5006 20.0898 35.6869 21.3335 35.6869 22.6211C35.6869 23.9088 35.5006 25.1523 35.1534 26.3274C33.9027 30.5629 30.5629 33.9027 26.3274 35.1534ZM43.7368 17.9533C41.9334 9.75918 35.483 3.30888 27.289 1.50537C25.786 1.17411 24.2242 0.999996 22.6211 0.999996C21.018 0.999996 19.4562 1.17411 17.9532 1.50537C9.75918 3.30888 3.30889 9.75918 1.50537 17.9533C1.17411 19.4562 1 21.018 1 22.6211C1 24.2242 1.17411 25.786 1.50537 27.289C3.30889 35.483 9.75918 41.9334 17.9532 43.7368C19.4562 44.0682 21.018 44.2422 22.6211 44.2422C24.2242 44.2422 25.786 44.0682 27.289 43.7368C35.483 41.9334 41.9334 35.483 43.7368 27.289C44.0682 25.786 44.2422 24.2242 44.2422 22.6211C44.2422 21.018 44.0682 19.4562 43.7368 17.9533Z",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3018_605",
    x1: 5.62109,
    y1: 5.12109,
    x2: 42.6211,
    y2: 44.1211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/HelpCenter.ae83b2546143860e22c1160829329cc6.svg";
export { ForwardRef as ReactComponent };